const getDefaultEventsState = () => {
  return {
    allEvents: [],
  }
}

export default getDefaultEventsState()
export { getDefaultEventsState }
